import { render, staticRenderFns } from "./Tipps.vue?vue&type=template&id=02873259&scoped=true&"
import script from "./Tipps.vue?vue&type=script&lang=js&"
export * from "./Tipps.vue?vue&type=script&lang=js&"
import style0 from "./Tipps.vue?vue&type=style&index=0&id=02873259&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02873259",
  null
  
)

export default component.exports